import { render, staticRenderFns } from "./FiltersPanel.vue?vue&type=template&id=dc6d72a8&scoped=true"
import script from "./FiltersPanel.vue?vue&type=script&lang=js"
export * from "./FiltersPanel.vue?vue&type=script&lang=js"
import style0 from "./FiltersPanel.vue?vue&type=style&index=0&id=dc6d72a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6d72a8",
  null
  
)

export default component.exports